import Header from './Footer';

export default Header;
